import getReport from './getReport'
import getReportTemplates from './getReportTemplates'

export const reports = {
  getReport,
  getReportTemplates,
}
